































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import userStore from '@/modules/auth/auth.store'
import DiscussionMessage from './DiscussionMessage'
import {
  TeamPostEntity,
  TournamentTeamPostAPI,
  TournamentTeamPostEntity
} from '@/api/tournamentTeamPost'
import ServerError from '@/utils/server_error'
import { avatarInitial } from '@/utils/avatar'
import { ConfirmDialog } from '@/modules/shared/components/ConfirmDialog'
import layoutStore from '@/modules/shared/layout.store'
import tournamentStore from '@/modules/tournament/tournament.store'
import memberStore from '@/modules/member/member.store'
import {
  TournamentTeamEntity,
  TournamentTeamRole,
  TournamentTeamState
} from '@/api/tournamentTeam'
import TeamLFGManagement from './TeamLFGManagement'
import { HubConnection } from '@microsoft/signalr'
import { CancelError, CancellationToken } from '@/utils/cancel'
import { getRealtimeConnection, realtimeEventTarget } from '@/utils/realtime'
import {
  TournamentEntity,
  TournamentState,
  TournamentAPI
} from '@/api/tournament'
import { UserAvatar } from '@/modules/shared/components/UserAvatar'
import LFGJoinActionDialog from './LFGJoinActionDialog'
import { IdentityAPI } from '@/api/identity'
import { ensureTournamentVerification } from '@/utils/verification'

@Component({
  components: {
    DiscussionMessage,
    ConfirmDialog,
    TeamLFGManagement,
    UserAvatar,
    LFGJoinActionDialog
  }
})
export default class TournamentLFGModal extends Vue {
  @Prop({ type: String, default: '' }) tournamentTeamId!: string

  userModule = getModule(userStore, this.$store)
  layoutModule = getModule(layoutStore, this.$store)
  tournamentModule = getModule(tournamentStore, this.$store)
  memberModule = getModule(memberStore, this.$store)
  selectedMatchRoster: string[] = []
  isLoading: boolean = false

  posts: TeamPostEntity | null = null
  replyMessage: string = ''
  submittingReply: boolean = false

  editMessage: string = ''
  editDialogVisible: boolean = false
  requestJoinVisible: boolean = false
  manageDialogVisible: boolean = false
  cancelRequestVisible: boolean = false
  unpublishRequestVisible: boolean = false

  realtimeConnection!: HubConnection
  realtimeConnectionCancellationToken = new CancellationToken()

  @Ref('content') readonly chatContent!: HTMLDivElement

  /* Watchers */
  @Watch('isVisible')
  async onVisibilityChanged(visible: boolean) {
    if (visible) {
      await this.fetchData()

      // connect real time
      try {
        this.realtimeConnection = await getRealtimeConnection(
          this.realtimeConnectionCancellationToken
        )
      } catch (err) {
        if (err instanceof CancelError) {
          return
        }

        this.$toast.error(
          this.$t('TeamRegistrationStatus.FailConnectServerMessage')
        )
        console.error(err)
      }

      this.realtimeConnection.on(
        'tournamentTeamPostEdited',
        this.onTournamentTeamPostEdited
      )
      this.realtimeConnection.on(
        'tournamentTeamPostCommentUpdated',
        this.onTournamentTeamPostEdited
      )

      realtimeEventTarget.addEventListener(
        'reconnected',
        this.onRealtimeReconnected
      )
    } else {
      await this.destroyRealtime(this.tournamentTeamId)
      this.posts = null
      this.replyMessage = ''
      this.submittingReply = false

      this.editMessage = ''
      this.editDialogVisible = false
      this.requestJoinVisible = false
      this.manageDialogVisible = false
      this.cancelRequestVisible = false
      this.unpublishRequestVisible = false
    }
  }

  @Watch('tournamentTeamId')
  async onTournamentTeamIdChanged(
    newTournamentTeamId: string,
    oldTournamentTeamId: string
  ) {
    try {
      this.realtimeConnection = await getRealtimeConnection(
        this.realtimeConnectionCancellationToken
      )
    } catch (err) {
      if (err instanceof CancelError) {
        return
      }

      this.$toast.error(
        this.$t('TeamRegistrationStatus.FailConnectServerMessage')
      )
      console.error(err)
    }

    if (oldTournamentTeamId) {
      await this.realtimeConnection.send(
        'UnsubscribeTournamentTeam',
        oldTournamentTeamId
      )
      await this.destroyRealtime(oldTournamentTeamId)
    }

    if (newTournamentTeamId) {
      await this.realtimeConnection.send(
        'SubscribeTournamentTeam',
        newTournamentTeamId
      )
      await this.fetchData()
    }
  }

  /* Hooks */
  async created() {
    if (this.$route.params.tournamentTeamId) {
      await this.layoutModule.showLFGModal(
        this.tournamentModule.selectedTournamentTeam!.tournamentTeamId
      )
    }
  }

  async beforeDestroy() {
    this.realtimeConnectionCancellationToken.cancel()
    this.destroyRealtime(this.tournamentTeamId)
  }

  /* Methods */
  close() {
    this.layoutModule.hideLFGModal()
  }

  popEditDialog() {
    this.editMessage = this.posts!.message
    this.editDialogVisible = true
  }

  popManageDialog() {
    this.manageDialogVisible = true
  }

  closeEditDialog() {
    this.editDialogVisible = false
  }

  async setActionDialogVisible() {
    if (
      !(await ensureTournamentVerification({
        tournament: this.tournamentModule.selectedTournament!,
        callback: this.setActionDialogVisible
      }))
    ) {
      return
    }
    this.requestJoinVisible = true
  }

  async onRealtimeReconnected() {
    // ensure we have subscribed the tournament team
    if (this.selectedTournament && this.selectedTournamentTeam) {
      await this.realtimeConnection.send(
        'SubscribeTournamentTeam',
        this.selectedTournamentTeam.tournamentTeamId
      )
    }

    // fetch new data
    await this.fetchData()
  }

  async destroyRealtime(tournamentTeamId: string) {
    if (this.realtimeConnection) {
      await this.realtimeConnection.send(
        'UnsubscribeTournamentTeam',
        tournamentTeamId
      )
      this.realtimeConnection.off(
        'tournamentTeamPostEdited',
        this.onTournamentTeamPostEdited
      )
      this.realtimeConnection.off(
        'tournamentTeamPostCommentUpdated',
        this.onTournamentTeamPostCommentUpdated
      )
    }

    realtimeEventTarget.removeEventListener(
      'reconnected',
      this.onRealtimeReconnected
    )
  }

  async onTournamentTeamPostEdited() {
    await this.fetchData()
    this.$nextTick(() => {
      this.chatContent.scrollTop = 0
    })
  }

  async onTournamentTeamPostCommentUpdated(commenterMemberId: string) {
    if (commenterMemberId !== this.userId) {
      await this.fetchData()
    }
  }

  async onJoinRequestConfirmed(formResponse: any) {
    if (this.isPostOwner) return

    try {
      const response = await TournamentTeamPostAPI.requestToJoin(
        this.tournamentTeamId
      )
      if (response.data.status) {
        await this.fetchData()
        this.$toast.success(this.$t('TournamentLFGModal.RequestSentToCaptain'))

        // when join requested with form response received.
        if (formResponse) {
          this.submitTournamentFormResponse(formResponse)
        }
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Match.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.requestJoinVisible = false
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.tournamentModule.selectedTournament!.tournamentId
      )
    }
  }

  async onCancelRequestConfirmed() {
    if (this.isPostOwner) return

    try {
      const response = await TournamentTeamPostAPI.leaveTeam(
        this.tournamentTeamId
      )
      if (response.data.status) {
        await this.fetchData()
        this.$toast.success(this.$t('TournamentLFGModal.JoinRequestCancelled'))
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Match.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.cancelRequestVisible = false
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.tournamentModule.selectedTournament!.tournamentId
      )
    }
  }

  async onUnpublishPostRequestConfirmed() {
    if (!this.isPostOwner) return

    try {
      const response = await TournamentTeamPostAPI.unpublishTeam(
        this.tournamentTeamId
      )
      if (response.data.status) {
        await this.fetchData()
        this.$toast.success(
          this.$t('TournamentLFGModal.RecruitmentPostUnpublished')
        )
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Match.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.unpublishRequestVisible = false
      await this.tournamentModule.getMemberJoinedTournamentTeam(
        this.tournamentModule.selectedTournament!.tournamentId
      )
      this.$emit('refresh')
      this.close()
    }
  }

  async submitReply() {
    if (!this.replyMessage.trim().length) return

    this.submittingReply = true

    try {
      const response = await TournamentTeamPostAPI.replyTeamPost(
        this.tournamentTeamId,
        this.replyMessage
      )
      if (response.data.status) {
        await this.fetchData()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Match.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.replyMessage = ''
      this.submittingReply = false
    }
  }

  async submitTournamentFormResponse(formResponse: string) {
    try {
      const response = await TournamentAPI.submitTournamentFormResponse(
        this.tournamentTeamId,
        JSON.stringify(formResponse)
      )
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('TournamentActionDialog.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  async fetchData() {
    if (!this.tournamentTeamId) return

    try {
      this.isLoading = true
      const response = await TournamentTeamPostAPI.getTeamPostDetails(
        this.tournamentTeamId
      )
      let payload = response.data.payload
      if (payload) {
        this.posts = payload
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Match.SystemErrorMessage'))
        console.error(err)
      }
    } finally {
      this.isLoading = false
    }
  }

  async submitEditTeamPost() {
    if (!this.editMessage || !this.posts) {
      return
    }
    try {
      const response = await TournamentTeamPostAPI.updateTeamPost(
        this.tournamentTeamId,
        this.editMessage
      )
      if (response.data.status) {
        this.$toast.info(this.$t('TournamentLFGModal.MessageEdited'))
        await this.fetchData()
        this.closeEditDialog()
      }
    } catch (err) {
      if (err instanceof ServerError) {
        this.$toast.error(err.getMessage())
      } else {
        this.$toast.error(this.$t('Match.SystemErrorMessage'))
        console.error(err)
      }
    }
  }

  /* Computed Properties */
  get isVisible() {
    return this.layoutModule.tournamentLFGModalVisible
  }

  get selectedTournamentTeam(): TournamentTeamEntity | null {
    return this.tournamentModule.selectedTournamentTeam
  }

  get selectedTournament(): TournamentEntity | null {
    return this.tournamentModule.selectedTournament
  }

  get isPostOwner() {
    if (!this.posts) return false

    return this.userId === this.posts.member.memberId
  }

  get userId() {
    return this.userModule.memberId
  }

  get postComments() {
    if (!this.posts) return []

    return this.posts.comments.sort((a, b) => b.createTime - a.createTime)
  }

  get member() {
    return this.userModule.member
  }

  get teamAvatarName() {
    if (!this.posts) return ''

    return avatarInitial(this.posts.tournamentTeam.name)
  }

  get hasLoggedIn() {
    return this.userModule.hasLoggedIn
  }

  get hasJoinedTournament() {
    return !!this.tournamentModule.selectedTournamentTeam
  }

  get isAbleToCancel() {
    let userTeam = this.tournamentModule.selectedTournamentTeam
    if (!userTeam) {
      return false
    }
    let isUserJoined = userTeam.tournamentTeamId === this.tournamentTeamId

    let userTeamDetail = userTeam.players.find(
      player => player.memberId === this.userId
    )

    if (!userTeamDetail) return false
    if (!this.selectedTournament) return false

    return (
      isUserJoined &&
      userTeamDetail.role === TournamentTeamRole.RequestToJoin &&
      this.selectedTournament.state === TournamentState.OpenRegistration
    )
  }

  get userHasTeam() {
    let userTeam = this.tournamentModule.selectedTournamentTeam
    return !!userTeam
  }

  get userIsCurrentTeamMember() {
    let userTeam = this.tournamentModule.selectedTournamentTeam
    if (!userTeam) {
      return false
    }
    return userTeam.tournamentTeamId === this.tournamentTeamId
  }

  get isTournamentTeamRegistered() {
    if (!this.posts) {
      return false
    }
    return this.posts.tournamentTeam.state === TournamentTeamState.Registered
  }

  get isTeamActionButtonVisible() {
    return !this.isPostOwner || this.isTournamentTeamRegistered
  }

  get TournamentState() {
    return TournamentState
  }
}
